import { render, staticRenderFns } from "./StatGeneralInformation.vue?vue&type=template&id=1023b5bf&scoped=true&"
import script from "./StatGeneralInformation.vue?vue&type=script&lang=js&"
export * from "./StatGeneralInformation.vue?vue&type=script&lang=js&"
import style0 from "./StatGeneralInformation.vue?vue&type=style&index=0&id=1023b5bf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1023b5bf",
  null
  
)

export default component.exports